import { Container } from 'unstated'
import { unlockLesson } from '../../../API/Course'
import { formatLinks, groupMediaByType } from '../Utilities/Utilities'

const initialState = {
  loading: true,
  courseID: '',
  chapters: [],
  activeChapter: 0,
  userType: 'guest',
}

export default class CourseContentStore extends Container {
  name = 'CourseContentStore'

  contentAccessDB = null

  state = initialState

  init = async (id, chapters, userType) => {
    await this.setState({
      userType,
      courseID: id,
      chapters: chapters.map((chapter) => ({
        ...chapter,
        lessons: chapter.lessons.map((lesson) => ({
          ...lesson,
          media: [...groupMediaByType(lesson.media), formatLinks(lesson.links)],
        })),
      })),
      loading: false,
    })
    console.log(this.state)
  }

  setActiveChapter = (index) => this.setState({ activeChapter: index })

  setupAccessControls = async (enrollmentID) => {
    await this.setState({ enrollmentID })
  }

  unlockLesson = async (lessonIndex) => {
    const { enrollmentID, activeChapter } = this.state
    await unlockLesson(enrollmentID, activeChapter, lessonIndex)
  }
}
